
import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex)
// 初始化时用sessionStore.getItem('token'),这样子刷新页面就无需重新登录
export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token'),  //存到cookies中一样
    LOADING: false,
  },
  mutations: {
    LOGIN: (state, data) => {
      //更改token的值
      state.token = data;
      // console.log(data)
      localStorage.setItem('token', data);
    },
    loadStatus(state,flag) {
      state.LOADING = flag
    }
  }
})
